import _ from 'lodash';

import '~/above-the-fold.css';
import $ from '~makosh/assets/qwery';
import bean from '~makosh/assets/bean';
import SWFPopup from '~/components/swf-popup.js';
import ImgPopup from '~/components/img-popup.js';

if (document.querySelector('.b-page.cradle-page')) {
    const $cradlePage = $('.b-page.cradle-page');
    const $showSwfLink = $('.show-swf-link', $cradlePage);

    bean.on($showSwfLink[0], 'click', () =>
        new SWFPopup({
            url: $showSwfLink[0].dataset['url'],
            width: $showSwfLink[0].dataset['width'],
            height: $showSwfLink[0].dataset['height'],
        })
    );
}
if (document.querySelector('.b-page.cradle-page, .b-page.poncho-page')) {
    const $page = $('.b-page.cradle-page, .b-page.poncho-page');

    bean.on($page[0], 'click', '.img-popup-link', e =>
        new ImgPopup({
            url: $(e.target).selfOrParent('a')[0].dataset['url'],
        })
    );
}



// WEBPACK FOOTER //
// ./legacy/assets/index.js